import React, { createContext, useContext, useState, useCallback } from 'react';
import { PayoffDiagramModal } from '../components/PayoffDiagramModal';

// Create context for payoff diagram
const PayoffDiagramContext = createContext(null);

// Provider component
export const PayoffDiagramProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  
  const openPayoffDiagram = useCallback((pos, price) => {
    setPosition(pos);
    setCurrentPrice(price);
    setIsOpen(true);
  }, []);
  
  const closePayoffDiagram = useCallback(() => {
    setIsOpen(false);
    // Don't clear position immediately to allow for smooth animation
    setTimeout(() => {
      setPosition(null);
      setCurrentPrice(null);
    }, 300);
  }, []);
  
  return (
    <PayoffDiagramContext.Provider value={{ openPayoffDiagram, closePayoffDiagram }}>
      {children}
      <PayoffDiagramModal
        isOpen={isOpen}
        onClose={closePayoffDiagram}
        position={position}
        currentStockPrice={currentPrice}
      />
    </PayoffDiagramContext.Provider>
  );
};

// Hook to use payoff diagram
export const usePayoffDiagram = () => {
  const context = useContext(PayoffDiagramContext);
  if (!context) {
    throw new Error('usePayoffDiagram must be used within PayoffDiagramProvider');
  }
  return context;
};

export default PayoffDiagramProvider;
